

import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IArticleFilter } from "../models/filters/articleFilter";
import { IArticleForm } from "../models/forms/articleForm";
import { IArticlePDTO } from "../models/dtos/articlePDTO";

export default class ArticleService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/Article";

    protected static override  getUrlFilter<F extends IArticleFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.code != undefined)
                url += `&Code=${filter.code}`;
        }
        
        return url;
    }

    public static override toDTO(obj:IArticleForm):IArticlePDTO {
        const dto = super.toDTO(obj) as IArticlePDTO;
        return dto;
    }
}
